import { render, staticRenderFns } from "./detail.vue?vue&type=template&id=1f5a851e"
import script from "./detail.vue?vue&type=script&lang=js"
export * from "./detail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/app/erp_frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1f5a851e')) {
      api.createRecord('1f5a851e', component.options)
    } else {
      api.reload('1f5a851e', component.options)
    }
    module.hot.accept("./detail.vue?vue&type=template&id=1f5a851e", function () {
      api.rerender('1f5a851e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/center-business/purchase/return/result/detail.vue"
export default component.exports